import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useConnectionStatus } from '../hooks/useConnectionStatus';

const NoConnectionPage: React.FC = () => {
    const { strings } = useLanguage();
    const isOnline = useConnectionStatus();
    const [isRetrying, setIsRetrying] = useState(false);
    
    const handleRetry = () => {
        setIsRetrying(true);
        
        // Check if we're online according to navigator.onLine
        if (navigator.onLine) {
            // If online, reload the page
            window.location.reload();
        } else {
            // Still offline, reset button state
            setTimeout(() => {
                setIsRetrying(false);
            }, 1000);
        }
    };

    return (
        <div className="no-connection-page">
            <div className="no-connection-container">
                <div className="no-connection-icon">
                    <svg width="120" height="120" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 9L12 2L23 9V20C23 20.5304 22.7893 21.0391 22.4142 21.4142C22.0391 21.7893 21.5304 22 21 22H3C2.46957 22 1.96086 21.7893 1.58579 21.4142C1.21071 21.0391 1 20.5304 1 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 2V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </div>
                
                <h1 className="no-connection-title">
                    {strings.NO_CONNECTION_TITLE}
                </h1>
                
                <p className="no-connection-description">
                    {strings.NO_CONNECTION_DESCRIPTION}
                </p>
                
                <div className="no-connection-tips">
                    <h3>{strings.NO_CONNECTION_TIPS_TITLE}</h3>
                    <ul>
                        <li>{strings.NO_CONNECTION_TIP_1}</li>
                        <li>{strings.NO_CONNECTION_TIP_2}</li>
                        <li>{strings.NO_CONNECTION_TIP_3}</li>
                        <li>{strings.NO_CONNECTION_TIP_4}</li>
                    </ul>
                </div>
                
                <button 
                    className="retry-button"
                    onClick={handleRetry}
                    disabled={isRetrying}
                >
                    {isRetrying ? '...' : strings.RETRY_BUTTON}
                </button>
            </div>
        </div>
    );
};

export default NoConnectionPage;
